module.exports = __webpack_public_path__ + "static/media/8H.a3d87fdd.svg";